const KEY = "wj_consent_v1";
const ADS_ID = "AW-18292001351";
export const CONSENT_EVENT = "webjesters:consent-change";
export const OPEN_SETTINGS_EVENT = "webjesters:cookie-settings";

const GRANTED = { ad_storage: "granted", ad_user_data: "granted", ad_personalization: "granted", analytics_storage: "granted" };
const DENIED = { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "denied" };

const gtag = (...args) => {
  if (typeof window.gtag === "function") window.gtag(...args);
};

export function hasGPC() {
  return typeof navigator !== "undefined" && navigator.globalPrivacyControl === true;
}

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function loadGtag() {
  if (document.getElementById("wj-gtag")) return;
  const s = document.createElement("script");
  s.id = "wj-gtag";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
  document.head.appendChild(s);
  gtag("js", new Date());
  gtag("config", ADS_ID);
}

export function applyConsent(rec) {
  if (rec?.ads) {
    gtag("consent", "update", GRANTED);
    loadGtag();
  } else {
    gtag("consent", "update", DENIED);
  }
}

export function setConsent(ads) {
  const rec = { ads: Boolean(ads), ts: new Date().toISOString(), gpc: hasGPC(), v: 1 };
  try {
    localStorage.setItem(KEY, JSON.stringify(rec));
  } catch {}
  applyConsent(rec);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: rec }));
  return rec;
}

// Returns the stored decision, auto-declines on a Global Privacy Control signal, or null when the banner should show.
export function initConsent() {
  const rec = getConsent();
  if (rec) {
    applyConsent(rec);
    return rec;
  }
  if (hasGPC()) return setConsent(false);
  return null;
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
}
